import React, { memo } from 'react'
import { Stack } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

interface Props {
  children?: React.ReactNode
  sx?: SxProps<Theme>
}
const SpaceApartBox = ({ children, sx, ...props }: Props) => {
  return (
    <Stack
      display='flex'
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      spacing={1}
      {...props}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Stack>
  )
}

export default memo(SpaceApartBox)
